module.exports = __webpack_public_path__ + "static/img/over.aa9f5bf9.png";